module.exports = __webpack_public_path__ + "static/media/van-mini.44abe659.png";